const L = {
  name: "PlatformBusinessStructure",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.9998 1.83374L14.9435 5.99993L11.9747 7.78119L13.9228 9.07994L15.9998 7.83374L22.9435 11.9999L15.9998 16.1661L13.9228 14.9199L11.9747 16.2187L14.9435 17.9999L7.9998 22.1661L1.05615 17.9999L7.9998 13.8337L10.077 15.0801L12.0251 13.7813L9.05615 11.9999L12.0251 10.2185L10.077 8.91979L7.9998 10.1661L1.05615 5.99993L7.9998 1.83374ZM4.94345 5.99993L7.9998 7.83374L11.0562 5.99993L7.9998 4.16612L4.94345 5.99993ZM12.9435 11.9999L15.9998 13.8337L19.0562 11.9999L15.9998 10.1661L12.9435 11.9999ZM7.9998 19.8337L11.0562 17.9999L7.9998 16.1661L4.94345 17.9999L7.9998 19.8337Z" fill="currentColor"/>
</svg>
  `
};
export {
  L as PlatformBusinessStructure
};
